define([
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/util",
	"csi/xml"
], function(Action,ActionFactory,util,xml) {

	return ActionFactory.declare("MoveFrom", Action, {
		// String: default tag for action
		m_tag: "MoveFrom",

		constructor: function(obj) {
			this.idForm = util.getProperty(obj, "Form", "");			// optional form to show for each selection
			this.m_typeNodeHint = util.getProperty(obj, "Type", "");	// optional hint to name action

			// set defaults for action if not explicitly configured
			this.m_id = this.m_id || (this.m_tag + this.m_typeNodeHint);
			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		isValid: function()	{
			return this.m_viewRef && this.inherited(arguments);
		},

		_getNameParams: function(/*LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			return [lr.getTypePlural(this.m_typeNodeHint)];
		}
	});
});